// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/ask.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/say.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/update.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../images/tag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../images/ask-hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../images/say-hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../images/update-hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../images/tag-hover.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content_content__gM-jI {
  position: relative;
}

.Content_container__m-\\+Ba {
  position: relative;
  width: 100%;
  /* width: 278px; */
  /* height: 150px; */
  padding-top: 9px;
}

.Content_rect__dd1kd {
  overflow: scroll;
  position: sticky;
  height: 726px;
  width: 100%;
  position: absolute;
  /* width: 645px; */
  /* height: 150px; */
  background: #EFEEED;
  /* border: 1px solid #000; */
  z-index: 5;
  border-radius: 20px 0px 0px 0px;
  border: solid 1px #dee0e1;
  scrollbar-width: none;
  scrollbar-color: #6b71c9;
}
.Content_rect__dd1kd::-webkit-scrollbar {
  width: 0px;
}

.Content_roundcontentandroundborder__Xr3eq {
  position: relative;
}
.Content_roundcontent__s8eHv {
  position: absolute;
  right: 0;
  bottom: 0px;
  width: 50%;
  height: 56px;
  background: #EFEEED;
  z-index: 6;
  text-align: center;
  border-radius: 25px 25px 0px 0px;
  justify-content: space-evenly;
  display: inline-flex;
  padding: 4px;
  border: solid 1px #dee0e1;
  border-bottom: none;
}
.Content_asksayNav__2793e {
  width: 100%;
}

.Content_asksayNav__2793e > ul {
  list-style: none;
  margin: 2px 0 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: space-between;
}
.Content_asksayNav__2793e > ul > li {
  display: inline-block;
  flex-basis: 25%;
}
.Content_asksayNav__2793e > ul > li > a {
  color: #373334;
  text-transform: uppercase;
  font-size: 11px;
  /* width: 75px; */
  display: block;
  text-align: center;
  padding-top: 24px;
  cursor: pointer;
  border-radius: 26px;
  padding-bottom: 4px;
}
.Content_asksayNav__2793e > ul > li.Content_ask__wIZGO a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center 4px no-repeat;
}
.Content_asksayNav__2793e > ul > li.Content_say__Xe7wS a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center 4px no-repeat;
}
.Content_asksayNav__2793e > ul > li.Content_update__29YpM a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center 4px no-repeat;
}
.Content_asksayNav__2793e > ul > li.Content_tag__Y8xCz a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center 4px no-repeat;
}
.Content_roundborder__JY7ta {
  border: none;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 50%;
  height: 52px;
  z-index: 4;
  text-align: center;
  border-radius: 25px 25px 0px 0px;
  border: solid 1px #dee0e1;
}

.Content_filterbuttons__Sz8ry {
  padding-top: 7px;
  position: absolute;
  /* box-shadow: 2px 3px 6px darkgrey; */
  width: 295px;
  border-radius: 25px 25px 0px 4px;
  right: 0px;
  top: 65px;
  display: inline-flex;
  z-index: -2;
  bottom: 3px;
  justify-content: space-evenly;
}
.Content_filterbuttons__Sz8ry > span {
  padding: 0px 0px 0px 8px;
}
.Content_images__nJaph {
  box-shadow: 2px 3px 6px darkgrey;
}

/* @media all and (max-width: 1440px){
     
    .roundcontent{
        top: -55px;
        left: 377px !important;
        width: 45.3%;
    }
    .roundborder{
        top:-56px;
        left: 377px !important;
        width: 45.3%;
    }
    }
    @media all and (max-width: 1366px){
     
        .roundcontent{
            left: 353px !important;
        }
        .roundborder{
            left: 354px !important;
        }
        }
        @media all and (max-width: 1200px){
     
            .roundcontent{
                left: 312px !important;
                width: 45.3% !important;


            }
            .roundborder{
                left: 313px !important;
                width: 45.3% !important;
            }
            }
    
   @media all and (max-width: 1024px){
  
.roundcontent{
    top: -55px;
    left: 220px;
    width: 54.3%;
}
.roundborder{
    top: -58px;
    left: 226px;
    width: 53.3%;
   
}
}

@media all and (max-width: 1280px){
     
    .roundcontent{
        top: -55px;
        left: 334px;
        width: 45.3%;
    }
    .roundborder{
        top:-56px;
        left: 334px;
        width: 45.3%;
    }
    } */
/* 
    @media all and (max-width: 800px){
        .rect{
            width: 370px;
        }  
        .roundcontent{
            top: -46px;
            left: 153px;
            width: 78%;
        }
        .roundborder{
            top:-45px;
            left: 152px;
            width: 77%;
        }
        } */

/* @media all and (max-width: 1440px){
            .rect{
                width: 690px;
            }  
            .roundcontent{

                width: 116%;
            }
            .roundborder{
                width: 116%;
            }
            } */
/* 
            @media all and (max-width: 1280px){
                .rect{
                    width: 610px;
                }  
                .roundcontent{
    left: 332px;
                    width: 100%;
                }
                .roundborder{
                    top: -45px;
                    width: 100%;
                    left: 332px;
                }
                } */
/* @media all and (max-width: 1440px){
    .rect{
        width: 690px;
    }  
    .roundcontent{
        top: -46px;
        left: 412px;
    }
    .roundborder{
        top:-46px;
        left: 413px;
    }
    } */

/* @media all and (max-width: 2560px){
        .rect{
            width: 1263px;
        }  
        .roundcontent{
            top: -46px;
            left: 735px;
            width: 190%;
        }
        .roundborder{
            top:-46px;
            left: 735px;
            width: 190%;
        }
        } */
/* 
 @media  and (max-width: 768px){
     */

/* @media all and (max-width: 768px)  {
    .roundcontent{
       
        left: 148px;
        width: 58.3%;
    }
    .roundborder{

        left: 148px;
        width: 58.3%;
    }
    
} */

/* @media all and (min-width: 300px)  {
    .roundcontent{
       
        left: 107px !important;
        width: 62.5% !important;
    }
    .roundborder{

        left: 107px;
        width: 62.3%;
    }
    
} */
/*
@media all and (max-width: 320px){
    .rect{
        width: 290px;
    }  
    .roundcontent{
        top: -47px;
        left: 104px;
        width: 67%;
        padding: 6px;
    }
    .roundborder{
        top: -45px;
        left: 103px;
        width: 67%;
    }
    
} */
.Content_paperbgcolor__dC4lj {
  background: transparent !important;
  margin-left: 0px !important;
  width: 100%;
  padding: 0px 20px;
}
.Content_tab__-zCWy {
  outline: none !important;
  border: none !important;
  color: #373334;
  opacity: 1;
  font-size: 12px;
  font-weight: 600 !important;
}

.Content_selectedTab__kAjnW {
  outline: none !important;
  border: none !important;
  color: #4795de !important; 
  opacity: 1 !important;
  transition: all 0.3s ease;
  font-weight: 800 !important;
}

.Content_askbutton__jJRhz {
  background-color: #2168b2;
  width: 5rem;
}
.Content_asksayNav__2793e > ul > li.Content_ask__wIZGO .Content_askbuttonimage__UAFvg {
  background: #2168b2 url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center 4px no-repeat;
  box-shadow: 0px 3px 6px #00000029;
  color: #fff;
}
.Content_asksayNav__2793e > ul > li.Content_say__Xe7wS .Content_saybuttonimage__kTkXB {
  background: #36b549 url(${___CSS_LOADER_URL_REPLACEMENT_5___}) center 4px no-repeat;
  box-shadow: 0px 3px 6px #00000029;
  color: #fff;
}
.Content_asksayNav__2793e > ul > li.Content_update__29YpM .Content_updatebuttonimage__cKJYm {
  background: #ef3f37 url(${___CSS_LOADER_URL_REPLACEMENT_6___}) center 4px no-repeat;
  box-shadow: 0px 3px 6px #00000029;
  color: #fff;
}
.Content_asksayNav__2793e > ul > li.Content_tag__Y8xCz .Content_tagbuttonimage__Mf-pS {
  background: #efba29 url(${___CSS_LOADER_URL_REPLACEMENT_7___}) center 4px no-repeat;
  box-shadow: 0px 3px 6px #00000029;
  color: #fff;
}
.Content_loader__vxRd1 {
  width: 30px !important;
  height: 30px !important;
  position: absolute;
  top: 30%;
  left: 45%;
}
.Content_nodata__KR8mI {
  width: 100%;
  padding-top: 30px;
  text-align: center;
}
.Content_MuiTabs-root__gp\\+an {
  margin-left: 0 !important;
}
@media all and (max-width: 991px) {
  .Content_roundcontent__s8eHv,
  .Content_roundborder__JY7ta {
    width: 100%;
    top: 0;
    border-radius: 25px;
  }
  .Content_rect__dd1kd {
    top: 80px;
    border-radius: 20px;
  }
}
@media all and (max-width: 991px) {
  .Content_roundcontentandroundborder__Xr3eq {
    position: relative;
    margin-bottom: 10px;
    /* top: 70%;
    z-index: 999;
    width: 90%;
    height: 50px;
    left: 5%; */
  }
  .Content_rect__dd1kd {
    top: unset;
    border-radius: 20px;
    height: 600px;
    position: relative;
  }
  .Content_roundcontent__s8eHv {
    position: static;
    width: 100%;

    border-radius: 20px;
  }
  .Content_roundborder__JY7ta {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/Content.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;EACV,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wEAA0D;AAC5D;AACA;EACE,wEAA0D;AAC5D;AACA;EACE,wEAA6D;AAC/D;AACA;EACE,wEAA0D;AAC5D;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA+DO;AACP;;;;;;;;;;;;;;;WAeW;;AAEX;;;;;;;;;;;eAWe;AACf;;;;;;;;;;;;;;mBAcmB;AACnB;;;;;;;;;;;;OAYO;;AAEP;;;;;;;;;;;;;;WAcW;AACX;;MAEM;;AAEN;;;;;;;;;;;;GAYG;;AAEH;;;;;;;;;;;;GAYG;AACH;;;;;;;;;;;;;;;;;GAiBG;AACH;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gFAAwE;EACxE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,gFAAwE;EACxE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,gFAA2E;EAC3E,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,gFAAwE;EACxE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;;IAEE,WAAW;IACX,MAAM;IACN,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB;;;;eAIW;EACb;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;;IAEX,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".content {\r\n  position: relative;\r\n}\r\n\r\n.container {\r\n  position: relative;\r\n  width: 100%;\r\n  /* width: 278px; */\r\n  /* height: 150px; */\r\n  padding-top: 9px;\r\n}\r\n\r\n.rect {\r\n  overflow: scroll;\r\n  position: sticky;\r\n  height: 726px;\r\n  width: 100%;\r\n  position: absolute;\r\n  /* width: 645px; */\r\n  /* height: 150px; */\r\n  background: #EFEEED;\r\n  /* border: 1px solid #000; */\r\n  z-index: 5;\r\n  border-radius: 20px 0px 0px 0px;\r\n  border: solid 1px #dee0e1;\r\n  scrollbar-width: none;\r\n  scrollbar-color: #6b71c9;\r\n}\r\n.rect::-webkit-scrollbar {\r\n  width: 0px;\r\n}\r\n\r\n.roundcontentandroundborder {\r\n  position: relative;\r\n}\r\n.roundcontent {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0px;\r\n  width: 50%;\r\n  height: 56px;\r\n  background: #EFEEED;\r\n  z-index: 6;\r\n  text-align: center;\r\n  border-radius: 25px 25px 0px 0px;\r\n  justify-content: space-evenly;\r\n  display: inline-flex;\r\n  padding: 4px;\r\n  border: solid 1px #dee0e1;\r\n  border-bottom: none;\r\n}\r\n.asksayNav {\r\n  width: 100%;\r\n}\r\n\r\n.asksayNav > ul {\r\n  list-style: none;\r\n  margin: 2px 0 0 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  flex-direction: row;\r\n  align-content: space-between;\r\n}\r\n.asksayNav > ul > li {\r\n  display: inline-block;\r\n  flex-basis: 25%;\r\n}\r\n.asksayNav > ul > li > a {\r\n  color: #373334;\r\n  text-transform: uppercase;\r\n  font-size: 11px;\r\n  /* width: 75px; */\r\n  display: block;\r\n  text-align: center;\r\n  padding-top: 24px;\r\n  cursor: pointer;\r\n  border-radius: 26px;\r\n  padding-bottom: 4px;\r\n}\r\n.asksayNav > ul > li.ask a {\r\n  background: url(../../images/ask.svg) center 4px no-repeat;\r\n}\r\n.asksayNav > ul > li.say a {\r\n  background: url(../../images/say.svg) center 4px no-repeat;\r\n}\r\n.asksayNav > ul > li.update a {\r\n  background: url(../../images/update.svg) center 4px no-repeat;\r\n}\r\n.asksayNav > ul > li.tag a {\r\n  background: url(../../images/tag.svg) center 4px no-repeat;\r\n}\r\n.roundborder {\r\n  border: none;\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 50%;\r\n  height: 52px;\r\n  z-index: 4;\r\n  text-align: center;\r\n  border-radius: 25px 25px 0px 0px;\r\n  border: solid 1px #dee0e1;\r\n}\r\n\r\n.filterbuttons {\r\n  padding-top: 7px;\r\n  position: absolute;\r\n  /* box-shadow: 2px 3px 6px darkgrey; */\r\n  width: 295px;\r\n  border-radius: 25px 25px 0px 4px;\r\n  right: 0px;\r\n  top: 65px;\r\n  display: inline-flex;\r\n  z-index: -2;\r\n  bottom: 3px;\r\n  justify-content: space-evenly;\r\n}\r\n.filterbuttons > span {\r\n  padding: 0px 0px 0px 8px;\r\n}\r\n.images {\r\n  box-shadow: 2px 3px 6px darkgrey;\r\n}\r\n\r\n/* @media all and (max-width: 1440px){\r\n     \r\n    .roundcontent{\r\n        top: -55px;\r\n        left: 377px !important;\r\n        width: 45.3%;\r\n    }\r\n    .roundborder{\r\n        top:-56px;\r\n        left: 377px !important;\r\n        width: 45.3%;\r\n    }\r\n    }\r\n    @media all and (max-width: 1366px){\r\n     \r\n        .roundcontent{\r\n            left: 353px !important;\r\n        }\r\n        .roundborder{\r\n            left: 354px !important;\r\n        }\r\n        }\r\n        @media all and (max-width: 1200px){\r\n     \r\n            .roundcontent{\r\n                left: 312px !important;\r\n                width: 45.3% !important;\r\n\r\n\r\n            }\r\n            .roundborder{\r\n                left: 313px !important;\r\n                width: 45.3% !important;\r\n            }\r\n            }\r\n    \r\n   @media all and (max-width: 1024px){\r\n  \r\n.roundcontent{\r\n    top: -55px;\r\n    left: 220px;\r\n    width: 54.3%;\r\n}\r\n.roundborder{\r\n    top: -58px;\r\n    left: 226px;\r\n    width: 53.3%;\r\n   \r\n}\r\n}\r\n\r\n@media all and (max-width: 1280px){\r\n     \r\n    .roundcontent{\r\n        top: -55px;\r\n        left: 334px;\r\n        width: 45.3%;\r\n    }\r\n    .roundborder{\r\n        top:-56px;\r\n        left: 334px;\r\n        width: 45.3%;\r\n    }\r\n    } */\r\n/* \r\n    @media all and (max-width: 800px){\r\n        .rect{\r\n            width: 370px;\r\n        }  \r\n        .roundcontent{\r\n            top: -46px;\r\n            left: 153px;\r\n            width: 78%;\r\n        }\r\n        .roundborder{\r\n            top:-45px;\r\n            left: 152px;\r\n            width: 77%;\r\n        }\r\n        } */\r\n\r\n/* @media all and (max-width: 1440px){\r\n            .rect{\r\n                width: 690px;\r\n            }  \r\n            .roundcontent{\r\n\r\n                width: 116%;\r\n            }\r\n            .roundborder{\r\n                width: 116%;\r\n            }\r\n            } */\r\n/* \r\n            @media all and (max-width: 1280px){\r\n                .rect{\r\n                    width: 610px;\r\n                }  \r\n                .roundcontent{\r\n    left: 332px;\r\n                    width: 100%;\r\n                }\r\n                .roundborder{\r\n                    top: -45px;\r\n                    width: 100%;\r\n                    left: 332px;\r\n                }\r\n                } */\r\n/* @media all and (max-width: 1440px){\r\n    .rect{\r\n        width: 690px;\r\n    }  \r\n    .roundcontent{\r\n        top: -46px;\r\n        left: 412px;\r\n    }\r\n    .roundborder{\r\n        top:-46px;\r\n        left: 413px;\r\n    }\r\n    } */\r\n\r\n/* @media all and (max-width: 2560px){\r\n        .rect{\r\n            width: 1263px;\r\n        }  \r\n        .roundcontent{\r\n            top: -46px;\r\n            left: 735px;\r\n            width: 190%;\r\n        }\r\n        .roundborder{\r\n            top:-46px;\r\n            left: 735px;\r\n            width: 190%;\r\n        }\r\n        } */\r\n/* \r\n @media  and (max-width: 768px){\r\n     */\r\n\r\n/* @media all and (max-width: 768px)  {\r\n    .roundcontent{\r\n       \r\n        left: 148px;\r\n        width: 58.3%;\r\n    }\r\n    .roundborder{\r\n\r\n        left: 148px;\r\n        width: 58.3%;\r\n    }\r\n    \r\n} */\r\n\r\n/* @media all and (min-width: 300px)  {\r\n    .roundcontent{\r\n       \r\n        left: 107px !important;\r\n        width: 62.5% !important;\r\n    }\r\n    .roundborder{\r\n\r\n        left: 107px;\r\n        width: 62.3%;\r\n    }\r\n    \r\n} */\r\n/*\r\n@media all and (max-width: 320px){\r\n    .rect{\r\n        width: 290px;\r\n    }  \r\n    .roundcontent{\r\n        top: -47px;\r\n        left: 104px;\r\n        width: 67%;\r\n        padding: 6px;\r\n    }\r\n    .roundborder{\r\n        top: -45px;\r\n        left: 103px;\r\n        width: 67%;\r\n    }\r\n    \r\n} */\r\n.paperbgcolor {\r\n  background: transparent !important;\r\n  margin-left: 0px !important;\r\n  width: 100%;\r\n  padding: 0px 20px;\r\n}\r\n.tab {\r\n  outline: none !important;\r\n  border: none !important;\r\n  color: #373334;\r\n  opacity: 1;\r\n  font-size: 12px;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.selectedTab {\r\n  outline: none !important;\r\n  border: none !important;\r\n  color: #4795de !important; \r\n  opacity: 1 !important;\r\n  transition: all 0.3s ease;\r\n  font-weight: 800 !important;\r\n}\r\n\r\n.askbutton {\r\n  background-color: #2168b2;\r\n  width: 5rem;\r\n}\r\n.asksayNav > ul > li.ask .askbuttonimage {\r\n  background: #2168b2 url(../../images/ask-hover.svg) center 4px no-repeat;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  color: #fff;\r\n}\r\n.asksayNav > ul > li.say .saybuttonimage {\r\n  background: #36b549 url(../../images/say-hover.svg) center 4px no-repeat;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  color: #fff;\r\n}\r\n.asksayNav > ul > li.update .updatebuttonimage {\r\n  background: #ef3f37 url(../../images/update-hover.svg) center 4px no-repeat;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  color: #fff;\r\n}\r\n.asksayNav > ul > li.tag .tagbuttonimage {\r\n  background: #efba29 url(../../images/tag-hover.svg) center 4px no-repeat;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  color: #fff;\r\n}\r\n.loader {\r\n  width: 30px !important;\r\n  height: 30px !important;\r\n  position: absolute;\r\n  top: 30%;\r\n  left: 45%;\r\n}\r\n.nodata {\r\n  width: 100%;\r\n  padding-top: 30px;\r\n  text-align: center;\r\n}\r\n.MuiTabs-root {\r\n  margin-left: 0 !important;\r\n}\r\n@media all and (max-width: 991px) {\r\n  .roundcontent,\r\n  .roundborder {\r\n    width: 100%;\r\n    top: 0;\r\n    border-radius: 25px;\r\n  }\r\n  .rect {\r\n    top: 80px;\r\n    border-radius: 20px;\r\n  }\r\n}\r\n@media all and (max-width: 991px) {\r\n  .roundcontentandroundborder {\r\n    position: relative;\r\n    margin-bottom: 10px;\r\n    /* top: 70%;\r\n    z-index: 999;\r\n    width: 90%;\r\n    height: 50px;\r\n    left: 5%; */\r\n  }\r\n  .rect {\r\n    top: unset;\r\n    border-radius: 20px;\r\n    height: 600px;\r\n    position: relative;\r\n  }\r\n  .roundcontent {\r\n    position: static;\r\n    width: 100%;\r\n\r\n    border-radius: 20px;\r\n  }\r\n  .roundborder {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Content_content__gM-jI`,
	"container": `Content_container__m-+Ba`,
	"rect": `Content_rect__dd1kd`,
	"roundcontentandroundborder": `Content_roundcontentandroundborder__Xr3eq`,
	"roundcontent": `Content_roundcontent__s8eHv`,
	"asksayNav": `Content_asksayNav__2793e`,
	"ask": `Content_ask__wIZGO`,
	"say": `Content_say__Xe7wS`,
	"update": `Content_update__29YpM`,
	"tag": `Content_tag__Y8xCz`,
	"roundborder": `Content_roundborder__JY7ta`,
	"filterbuttons": `Content_filterbuttons__Sz8ry`,
	"images": `Content_images__nJaph`,
	"paperbgcolor": `Content_paperbgcolor__dC4lj`,
	"tab": `Content_tab__-zCWy`,
	"selectedTab": `Content_selectedTab__kAjnW`,
	"askbutton": `Content_askbutton__jJRhz`,
	"askbuttonimage": `Content_askbuttonimage__UAFvg`,
	"saybuttonimage": `Content_saybuttonimage__kTkXB`,
	"updatebuttonimage": `Content_updatebuttonimage__cKJYm`,
	"tagbuttonimage": `Content_tagbuttonimage__Mf-pS`,
	"loader": `Content_loader__vxRd1`,
	"nodata": `Content_nodata__KR8mI`,
	"MuiTabs-root": `Content_MuiTabs-root__gp+an`
};
export default ___CSS_LOADER_EXPORT___;
